import script from "./ModalInvite.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalInvite.vue?vue&type=script&lang=ts&setup=true"

import "./ModalInvite.vue?vue&type=style&index=0&id=7e138a55&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e138a55"]])

export default __exports__